import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "user-join",
  class: "user-wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = {
  key: 1,
  class: "title"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "label-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "아이디")
], -1)
const _hoisted_6 = { class: "input-wrapper" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "button-area"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 1,
  class: "button-area"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "row"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "label-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "닉네임")
], -1)
const _hoisted_14 = { class: "input-wrapper" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "button-area" }, null, -1)
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "label-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "비밀번호")
], -1)
const _hoisted_18 = { class: "input-wrapper" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "button-area" }, null, -1)
const _hoisted_20 = { class: "row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "label-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "비밀번호 확인")
], -1)
const _hoisted_22 = { class: "input-wrapper" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "button-area" }, null, -1)
const _hoisted_24 = { class: "row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "label-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "이름")
], -1)
const _hoisted_26 = { class: "input-wrapper" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "button-area" }, null, -1)
const _hoisted_28 = { class: "row" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "label-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "생년월일")
], -1)
const _hoisted_30 = { class: "input-wrapper" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "button-area" }, null, -1)
const _hoisted_32 = { class: "row" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "label-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "이메일 주소")
], -1)
const _hoisted_34 = { class: "input-wrapper" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "button-area" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "description" }, " * 이름/생년월일/이메일 주소는 계정정보 찾기에 사용됩니다. ")
], -1)
const _hoisted_37 = { class: "row" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "label-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "성별")
], -1)
const _hoisted_39 = { class: "radio-wrapper" }
const _hoisted_40 = { class: "custom-radio" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "radio-custom" }, null, -1)
const _hoisted_42 = { class: "custom-radio" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "radio-custom" }, null, -1)
const _hoisted_44 = { class: "custom-radio" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "radio-custom" }, null, -1)
const _hoisted_46 = {
  key: 1,
  class: "row kakao-row"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "label-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "카카오 연동")
], -1)
const _hoisted_48 = { class: "kakao-wrapper" }
const _hoisted_49 = {
  key: 2,
  class: "row kakao-row"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "label-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "로또 결과 알림")
], -1)
const _hoisted_51 = { class: "kakao-wrapper" }
const _hoisted_52 = { class: "toggle-label" }
const _hoisted_53 = ["checked"]
const _hoisted_54 = {
  key: 3,
  class: "row"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "description kakao-description" }, " * 카카오 연동 후 로또 결과 알림을 수신하면 추첨결과를 카카오톡으로 받을 수 있습니다. ", -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = {
  key: 4,
  class: "row"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "label-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "약관동의")
], -1)
const _hoisted_59 = { class: "agree-wrapper" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", null, "약관에 동의합니다.", -1)
const _hoisted_61 = { class: "button-area" }
const _hoisted_62 = {
  key: 2,
  class: "modal"
}
const _hoisted_63 = { class: "modal-content" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("h2", null, "회원 탈퇴", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("p", null, "탈퇴를 원하시면 비밀번호를 입력하세요.", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("p", null, "즉시 모든 데이터가 삭제되며 복구되지 않습니다.", -1)
const _hoisted_67 = { class: "modal-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isRendering)
    ? (_openBlock(), _createElementBlock("article", _hoisted_1, [
        (_ctx.joinMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "회원가입"))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, "내 정보")),
        _createElementVNode("form", {
          class: "input-wrapper",
          onSubmit: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.requestJoin && _ctx.requestJoin(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                class: "input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.id) = $event)),
                placeholder: "4 ~ 32자리",
                ref: "idInput",
                autocomplete: "off",
                disabled: !_ctx.joinMode
              }, null, 8, _hoisted_7), [
                [_vModelText, _ctx.id]
              ])
            ]),
            (_ctx.joinMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("button", {
                    type: "button duplicate",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.idDuplicateCheck())),
                    disabled: _ctx.idCheck
                  }, " 중복확인 ", 8, _hoisted_9)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openLeaveModal())),
                    disabled: _ctx.idCheck,
                    class: "leave"
                  }, " 탈퇴 ", 8, _hoisted_11)
                ]))
          ]),
          (!_ctx.joinMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    class: "input",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.nickname) = $event)),
                    placeholder: "표시 이름 (2~16자)",
                    maxlength: "16",
                    autocomplete: "off"
                  }, null, 512), [
                    [_vModelText, _ctx.nickname]
                  ])
                ]),
                _hoisted_15
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _withDirectives(_createElementVNode("input", {
                class: "input",
                placeholder: "8자에서 24자리",
                ref: "passwordInput",
                type: "password",
                autocomplete: "new-password",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.password) = $event))
              }, null, 512), [
                [_vModelText, _ctx.password]
              ])
            ]),
            _hoisted_19
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _withDirectives(_createElementVNode("input", {
                class: "input",
                placeholder: "8자에서 24자리",
                type: "password",
                autocomplete: "off",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.confirmPassword) = $event))
              }, null, 512), [
                [_vModelText, _ctx.confirmPassword]
              ])
            ]),
            _hoisted_23
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _withDirectives(_createElementVNode("input", {
                class: "input",
                placeholder: "2자에서 32자",
                ref: "nameInput",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.name) = $event))
              }, null, 512), [
                [_vModelText, _ctx.name]
              ])
            ]),
            _hoisted_27
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _withDirectives(_createElementVNode("input", {
                class: "input",
                placeholder: "2020-01-01",
                ref: "birthInput",
                onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.formatBirthDate && _ctx.formatBirthDate(...args))),
                maxlength: "10",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.birth) = $event))
              }, null, 544), [
                [_vModelText, _ctx.birth]
              ])
            ]),
            _hoisted_31
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("div", _hoisted_34, [
              _withDirectives(_createElementVNode("input", {
                class: "input",
                placeholder: "4자에서 32자리",
                ref: "emailInput",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.email) = $event))
              }, null, 512), [
                [_vModelText, _ctx.email]
              ])
            ]),
            _hoisted_35
          ]),
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("label", _hoisted_40, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "gender",
                  value: "0",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedGender) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.selectedGender]
                ]),
                _hoisted_41,
                _createTextVNode(" 선택 안 함 ")
              ]),
              _createElementVNode("label", _hoisted_42, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "gender",
                  value: "1",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedGender) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.selectedGender]
                ]),
                _hoisted_43,
                _createTextVNode(" 남자 ")
              ]),
              _createElementVNode("label", _hoisted_44, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "gender",
                  value: "2",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedGender) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.selectedGender]
                ]),
                _hoisted_45,
                _createTextVNode(" 여자 ")
              ])
            ])
          ]),
          (!_ctx.joinMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["kakao-status", { linked: _ctx.kakaoLinked }])
                  }, _toDisplayString(_ctx.kakaoLinked ? '연동됨' : '미연동'), 3),
                  (!_ctx.kakaoLinked)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "kakao-button link",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.linkKakao()))
                      }, " 카카오 연동 "))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "kakao-button unlink",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.requestUnlinkKakao()))
                      }, " 연동 해제 "))
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.joinMode && _ctx.kakaoLinked)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("label", _hoisted_52, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: _ctx.kakaoLottoNotification,
                      onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.toggleLottoNotification()))
                    }, null, 40, _hoisted_53),
                    _createElementVNode("span", null, _toDisplayString(_ctx.kakaoLottoNotification ? '수신허용' : '수신거부'), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.joinMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_54, _hoisted_56))
            : _createCommentVNode("", true),
          (_ctx.joinMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                _hoisted_58,
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.agreeToTerms) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.agreeToTerms]
                    ]),
                    _hoisted_60
                  ]),
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openTerms && _ctx.openTerms(...args)), ["prevent"]))
                  }, "약관 보기")
                ])
              ]))
            : _createCommentVNode("", true)
        ], 32),
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("button", {
            class: "button cancel",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.cancel()))
          }, "뒤로가기"),
          (_ctx.joinMode)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button submit",
                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.requestJoin()))
              }, " 가입신청 "))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "button submit",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.requestUpdate()))
              }, " 저장 "))
        ]),
        (_ctx.isLeaveModalOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _hoisted_64,
                _hoisted_65,
                _hoisted_66,
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.leavePassword) = $event)),
                  placeholder: "비밀번호",
                  class: "input"
                }, null, 512), [
                  [_vModelText, _ctx.leavePassword]
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("button", {
                    onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.closeLeaveModal && _ctx.closeLeaveModal(...args)))
                  }, "취소"),
                  _createElementVNode("button", {
                    onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.confirmLeave && _ctx.confirmLeave(...args)))
                  }, "확인")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}